module.exports = __webpack_public_path__ + "assets/img/idea@1,5x.6a8e8010.svg";